var exports = {
  "Q": "xdde3148b--263dfd--content",
  "q": "xdde3148b--263dfd--price",
};

module.exports = exports;
